import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from 'src/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      height: 120,
      borderRadius: 8,
      padding: 16,
      backgroundColor: '#FFFFFF',
      boxShadow: 'none',
      position: 'relative',

      '& .MuiCardHeader-root': {
        padding: 0,
      },

      '& .MuiCardHeader-title': {
        fontWeight: 400,
        fontSize: 14,
        marginBottom: 0,
        textAlign: 'left',
        color: variables.black50,
        textTransform: 'capitalize',
      },

      '& .MuiCardContent-root': {
        position: 'absolute',
        bottom: 10,
        width: '90%',
        paddingBottom: 0,
        paddingInlineStart: 0,
      },
    },
    bottomContent: {
      textAlign: 'start',
      marginTop: 4,
      display: 'flex',
      borderRadius: 4,
      paddingLeft: 4,
      height: 19,
      backgroundColor: variables.black5,
      color: variables.richBlack,
    },
    percentContent: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
      textAlign: 'start',
    },
    up: {
      backgroundColor: '#3BBB7A',
      color: variables.white,
    },
    down: {
      backgroundColor: '#FF8F94',
      color: variables.white,
    },
  }),
);
